import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Box from '@mui/material/Box'
import EditarIcon from '@mui/icons-material/Edit';

const session = require('../../config/session')

function Row(props) {
 const {funcionario} = props

 var estado = ""

 switch(funcionario.estado) {
  case "A":
    estado = "Activo"
    break
  case "I":
    estado = "Inactivo"
    break
  case "B":
    estado = "Baja"
    break
  default:
    break
 }

 var cajeros = []
 if (funcionario.cajeros != null) {
   const MAX_CAJEROS = 5
   const listaCajeros = funcionario.cajeros.split('**-**')
   listaCajeros.slice(0, MAX_CAJEROS).forEach((cajero, index) => {
     cajeros.push(
       <span key={`cajero-${index}`}>* {cajero}<br /></span>
     );
   });
   if (listaCajeros.length > MAX_CAJEROS) {
     const restantes = listaCajeros.length - MAX_CAJEROS
     cajeros.push(
       <span key="cajero-mas" style={{ fontStyle: 'italic', color: '#555' }}>
         + {restantes} {restantes === 1 ? 'cajero' : 'cajeros'}
       </span>
     );
   }
 }

 // Roles: vienen dentro de funcionario.permisos = {roles:[{nombre,id}], permisos:[...]}
 var roles = []
 try {
   var permisosObj = JSON.parse(funcionario.permisos)
   if (permisosObj && Array.isArray(permisosObj.roles)) {
     permisosObj.roles.forEach((rol, index) => {
       roles.push(<span key={`rol-${index}`}>* {rol.nombre}<br /></span>)
     })
   }
 } catch (e) { }

 return (
   <TableRow>
     <TableCell>
       {funcionario.fecha_registro}
     </TableCell>
     <TableCell>
        {funcionario.nombre}
     </TableCell>
     <TableCell>
       {funcionario.codigo}
    </TableCell>
    <TableCell>
      {roles}
    </TableCell>
    <TableCell>
      {cajeros}
    </TableCell>
    <TableCell>
      {estado}
    </TableCell>
    <TableCell>
    {
      session.checkPermiso('acceder_funcionarios_editar') && 
      <Link to={{pathname: '/dashboard/funcionarios/editar', state: {id_funcionario: funcionario.id}}} style={{ textDecoration: 'none' }}><Button variant="contained" endIcon={<EditarIcon />} color="primary">Editar</Button></Link>
    }
    </TableCell>
  </TableRow>
 );
}


class FuncionariosTable extends Component {

  constructor(props) {
    super(props)

    this.state = {
      cajeros: []
    };
  }

  componentDidMount() {
  }

  render() {
    const funcionarios = this.props.funcionarios


    const columns = [
      {field: "fecha_registro", headerName: 'Fecha Registro', width: 250},
      {field: "nombre", headerName: 'Nombre', width: 220},
      {field: "codigo", headerName: 'Identificación', width: 170},
      {field: "rol", headerName: 'Rol', width: 200},
      {field: "cajeros", headerName: 'Cajeros', width: 250},
      {field: "estado", headerName: 'Estado', width: 100},
      {field: "", headerName: ''},
    ]

    return (
      <Box sx={{ maxWidth: 1200, overflow: 'hidden', borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        mb: 3 }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{
                  '& th': {
                    backgroundColor: 'primary.main',
                    color: 'primary.contrastText',
                    fontWeight: 'fontWeightBold',
                    fontSize: '0.8rem',
                    py: 1.5,
                    px: 2
                  }
                }}>
                {columns.map((column) => {
                  return(
                    <TableCell style={{width: column.width}} key={column.field}>{column.headerName}</TableCell>
                  )
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {funcionarios.map((funcionario, idx) => {
                return(
                  <Row key={idx} funcionario={funcionario} />
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    )
  }
}

export default FuncionariosTable;
